/**
 * @generated SignedSource<<76866b3473bf542744599aac1b51f305>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SnapshotDependenciesCountersQuery$variables = {
  locator: string;
};
export type SnapshotDependenciesCountersQuery$data = {
  readonly builds: {
    readonly count: number | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"SnapshotDependenciesCountersFragment">;
  } | null | undefined;
};
export type SnapshotDependenciesCountersQuery = {
  response: SnapshotDependenciesCountersQuery$data;
  variables: SnapshotDependenciesCountersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SnapshotDependenciesCountersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Builds",
        "kind": "LinkedField",
        "name": "builds",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SnapshotDependenciesCountersFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SnapshotDependenciesCountersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Builds",
        "kind": "LinkedField",
        "name": "builds",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "buildTypeInternalId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "failedToStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgressInfo",
                "kind": "LinkedField",
                "name": "runningInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "elapsedSeconds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedTotalSeconds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "54828bb97bde9f16c452f05fc8eda0fd",
    "id": null,
    "metadata": {},
    "name": "SnapshotDependenciesCountersQuery",
    "operationKind": "query",
    "text": "query SnapshotDependenciesCountersQuery(\n  $locator: String!\n) {\n  builds(locator: $locator) {\n    count\n    ...SnapshotDependenciesCountersFragment\n  }\n}\n\nfragment SnapshotDependenciesCountersFragment on Builds {\n  build {\n    buildTypeInternalId\n    status\n    state\n    failedToStart\n    runningInfo {\n      elapsedSeconds\n      estimatedTotalSeconds\n    }\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0c4bece9884f4686baf37adace1216d";

export default node;
